let autoSaveTimer = null;
let autoSaveToggle = false;

export function addCodeBlock(contentToAdd) {
  const actualContent = $('#content').trumbowyg('html');
  $('#content').trumbowyg('html', actualContent + contentToAdd);
}

export function addTitle(contentToAdd) {
  const actualContent = $('#content').trumbowyg('html');
  $('#content').trumbowyg('html', contentToAdd + actualContent);
}

function observeLength(fieldId, resultId) {
  const field = document.getElementById(fieldId);
  const result = document.getElementById(resultId);
  if (!field || !result) return;

  const min = field.getAttribute('minlength');
  const max = field.getAttribute('maxlength');

  const keyup = () => {
    result.innerHTML = field.value.length;
    const bad = field.value.length > max || field.value.length < min;
    result.style.color = bad ? 'red' : 'green';
  };
  field.addEventListener('keyup', keyup);
  field.dispatchEvent(new Event('keyup'));

  document.addEventListener('turbo:before-visit', () => field.removeEventListener('keyup', keyup), { once: true });
}

function changeSaveStatus(status) {
  ['wait', 'success', 'error', 'pending', 'disabled'].forEach((s) => {
    $(`#status-${s}`).css('display', status == s ? 'flex' : 'none');
  });
}

function showErrors(items) {
  $('#errors-messages').prop('hidden', false);
  $('#errors-messages ol').html(items.map(error => `<li>${error}</li>`).join(''));
}

function autoSave() {
  if (!autoSaveToggle) return;
  if (autoSaveTimer) clearTimeout(autoSaveTimer);

  const contentHTML = $('#content').trumbowyg('html');
  const url = $('#content').closest('form').attr('action');
  const siteId = $('#page_site_id').val();

  changeSaveStatus('pending');
  autoSaveTimer = setTimeout(() => {
    if (!autoSaveToggle) return;
    changeSaveStatus('wait');

    fetch(url, {
      method: 'PATCH',
      headers: {
        credentials: 'include',
        'content-type': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      },
      body: JSON.stringify({
        autosave: true,
        page: { site_id: siteId, content: contentHTML },
      }),
    }).then((data) => data.json()).then(data => {
      if (data.errors) {
        changeSaveStatus('error');
        showErrors(data.errors);
      } else {
        changeSaveStatus('success');
        $('#errors-messages').prop('hidden', true);
      }
    }).catch((error) => {
      changeSaveStatus('error');
      showErrors([error]);
    });
  }, 5000);
}

function toggleStatusBadge() {
  if (autoSaveToggle) {
    autoSave();
  } else {
    changeSaveStatus('disabled');
  }
}

function optionAutoSave() {
  autoSaveToggle = window.localStorage.getItem('autoSaveToggle') == 'true';
  $('#toggleAutoSave').prop('checked', autoSaveToggle);
  toggleStatusBadge();

  $('#toggleAutoSave').on('change', () => {
    autoSaveToggle = !autoSaveToggle;
    window.localStorage.setItem('autoSaveToggle', autoSaveToggle);
    toggleStatusBadge();
  });
}

document.addEventListener('turbo:load', () => {
  autoSaveTimer = null;
  autoSaveToggle = false;

  observeLength('page_description', 'description_length');
  observeLength('page_title', 'title_length');
  observeLength('page_permalink', 'permalink_length');

  const publishImmediately = document.getElementById('publish_immediately');
  const publishDate = document.getElementById('page_date');
  publishImmediately?.addEventListener('change', () => {
    publishDate.disabled = publishImmediately.checked;
  });

  $('#content').on('tbwinit', optionAutoSave);
  $('#content').on('tbwchange', autoSave);

  document.getElementById('edit-btn-relatives')?.addEventListener('click', () => {
    document.getElementById('relatives-editor').classList.toggle('d-none');
  });
});
